// extracted by mini-css-extract-plugin
module.exports = {"button-box":"button-box__18e3p","fixed-button":"fixed-button__1hMcT","fixed-button__prev":"fixed-button__prev__3nqiD"};